import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon, ButtonProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import DownloadIcon from "@tCentro/Icons/DownloadIcon";
import { COLORS } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: DownloadContainerStyles;
}

export interface DownloadContainerStyles {
    downloadVerticalIconWrapper?: InjectableCss;
    downloadIconWrapper?: InjectableCss;
}

export const downloadContainerStyles: DownloadContainerStyles = {
    downloadIconWrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            margin: 0px 8px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    downloadVerticalIconWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
            background: ${COLORS.white};
            border: 2px solid ${COLORS.background.grayShade};
            width: 48px;
            height: 48px;
            border-radius: 40px;
            &:hover {
             
                svg {
                    path {
                        fill: ${COLORS.white};
                    }
                }
            }
        `,
    },
};

const styles = downloadContainerStyles;

const DownloadContainer: FC<OwnProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.downloadIconWrapper}>
            <Button onClick={() => window.print()} {...styles.downloadVerticalIconWrapper}>
                <Icon src={DownloadIcon} />
            </Button>
        </StyledWrapper>
    );
};

const downloadContainer: WidgetModule = {
    component: DownloadContainer,
    definition: {
        group: "Product Details",
    },
};

export default downloadContainer;
